<div style="margin-top: 90px;"></div>
<section id="about" class="white-bg padding-top-bottom" style="padding: 30px 0;">

  <div class="container features">
    <h2 class="section-title">ALPATA GROUP</h2>
    <div class="row">

      <div class="col-sm-4 scrollimation fade-up in " style="width:100%; text-align:center;">

        <div class="media">
          <div class="media-body">
            <p>Alpata Group, founded in 1959, with headquarters in Eskisehir, Turkey, is composed of six companies
              operating in FMCG trade, automative, information technology, aerospace industry sectors. Alpata Group
              provides full time employment
              nearly 2000 people. Alpata Group partners with Sikorsky Aircraft (Lockheed Martin Company) and
              international giants such as Stellantis and Philip Morris Marketing and Sales Inc.</p>
          </div>
        </div>

      </div>

    </div>

  </div>

</section>
<section id="portfolio" class="gray-bg padding-top-bottom portfolio">

  <div class="container">
    <h2 class="section-title">ALPATA GROUP COMPANIES</h2>



    <br />
    <!--==== Portfolio Filters ====-->

    <div class="projects-container scrollimation">

      <div class="row">

        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in " data-id="246a96e9-6da5-4eba-8da2-b84c2416892a">
            <a href="en#alpatamarketing" class="main-link" (click)="GetCompanyCities(1)">
              <img class="img-responsive img-center"
                src="assets/images/company/246a96e9-6da5-4eba-8da2-b84c2416892a.en.png" alt="" />
              <h2 class="project-title">NECDET ALPATA MARKETING LOGISTICS AND TOURISM INDUSTRY AND TRADE INC.</h2>
              <span class="overlay-mask"></span>
            </a>
            <a class="link centered" (click)="GetCompanyCities(1)"><i class="fa fa-eye fa-fw"></i></a>
          </div>





        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in" data-id="3ad20862-0226-4548-ac82-e6487120c922">
            <a href="en#automotive" class="main-link" (click)="GetCompanyCities(2)">
              <img class="img-responsive img-center"
                src="assets/images/company/3ad20862-0226-4548-ac82-e6487120c922.en.png" alt="" />
              <h2 class="project-title">NECDET ALPATA AS. AUTOMOTIVE BRANCH</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(2)"><i class="fa fa-eye fa-fw"></i></a>
          </div>


        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in " data-id="2073de91-8cbe-4d99-adea-6305b30c2184">
            <a href="en#insurance" class="main-link" (click)="GetCompanyCities(3)">
              <img class="img-responsive img-center"
                src="assets/images/company/2073de91-8cbe-4d99-adea-6305b30c2184.en.png" alt="" />
              <h2 class="project-title">ALPATA INSURANCE BROKERAGE COMPANY </h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(3)"><i class="fa fa-eye fa-fw"></i></a>
          </div>


        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in " data-id="cbb2a481-ddfc-4850-88ff-95b98b4efeef">
            <a href="en#aviation" class="main-link" (click)="GetCompanyCities(4)">
              <img class="img-responsive img-center"
                src="assets/images/company/cbb2a481-ddfc-4850-88ff-95b98b4efeef.en.png" alt="" />
              <h2 class="project-title">ALP AVIATION </h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(4)"><i class="fa fa-eye fa-fw"></i></a>
          </div>


        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in" data-id="b15c2ea5-5819-45f9-a196-4fbca8860f6c">
            <a href="en#technologies" class="main-link" (click)="GetCompanyCities(5)">
              <img class="img-responsive img-center" src="assets/images/company/necdet-alpata-as-teknoloji-en.png"
                alt="" />
              <h2 class="project-title">NECDET ALPATA AS. TECHNOLOGY BRANCH</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(5)"><i class="fa fa-eye fa-fw"></i></a>
          </div>


        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in  " data-id="9fd40c5f-aa8d-4da2-8cec-85374ab956e2">
            <a href="en#alpteknikaviation" class="main-link" (click)="GetCompanyCities(6)">
              <img class="img-responsive img-center"
                src="assets/images/company/9fd40c5f-aa8d-4da2-8cec-85374ab956e2.en.png" alt="" />
              <h2 class="project-title">ALPTEKNIK AVIATION</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(6)"><i class="fa fa-eye fa-fw"></i></a>
          </div>


        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in  " data-id="b15c2ea5-5819-45f9-a196-4fbca8860f5c">
            <a href="en#alpatasrl" class="main-link" (click)="GetCompanyCities(7)">
              <img class="img-responsive img-center"
                src="assets/images/company/b15c2ea5-5819-45f9-a196-4fbca8860f5c.tr.png" alt="" />
              <h2 class="project-title">ALPATA S.R.L</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(7)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
        <article class="col-md-4 col-sm-6 project-item web-design apps psd">

          <div class="project-thumb in  " data-id="b15c2ea5-5819-45f9-a196-4fbca8860f5c">
            <a href="en#alpatasrl" class="main-link" (click)="GetCompanyCities(8)">
              <img class="img-responsive img-center"
                src="assets/images/company/2073de91-8cbe-4d99-adea-6305b30c2185.en.png" alt="" />
              <h2 class="project-title">ALPATA AEROSPACE</h2>
              <span class="overlay-mask"></span>
            </a>

            <a class="link centered" (click)="GetCompanyCities(8)"><i class="fa fa-eye fa-fw"></i></a>
          </div>
        </article>
      </div>
    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 1" id="alpatamarketing">
    <div id="preview-scroll"></div>
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(1)">×</a>
          <h1 class="preview-title">NECDET ALPATA MARKETING LOGISTICS AND TOURISM INDUSTRY AND TRADE INC.</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata-en.png">
          </div>
        </div>

        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/246a96e9-6da5-4eba-8da2-b84c2416892a_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">

              <p>The Group started its activities with the start up of Necdet Alpata A.Ş., one of Turkey's leading food,
                miscellaneous needs, tobacco products and beverage distribution, marketing and logistics companies, with
                the sale and distribution
                of Kızılay Mineral Water products in Eskişehir.</p>

              <p>The company is a regional leader in the distribution of FMCG in Central-Western Turkey in a geography
                covering Eskisehir, Bilecik, Usak, Kutahya & Mugla provinces. The Company distributes the products of
                major local and international
                FMCG brands such as Kızılay, Philip Morris Marketing and Sales Inc. , Erikli, Nestle Waters, Uludağ,
                Dimes, Doğuş, Haribo, Tat, Sleepy, Düzey, Pure Baby, Redbull.</p>

              <p>Proprietary solutions for field sales automation, video conferencing and distant sales are developed in
                recent years</p>
              <p>In the provinces where Necdet Alpata A.Ş. operates, there are 6 main logistics centers with a total
                area of approximately 25,000 m² and a total closed storage area of 15,000 m², as well as secondary
                warehouses. About 300 people
                work at the company headquarters and branches.</p>
              <p></p>


              <div class="col-md-12 text-center"><a
                  href="https://e-sirket.mkk.com.tr/esir/Dashboard.jsp#/sirketbilgileri/12981" target="_blank"
                  style="color:blue;">Bilgi Toplumu Hizmetleri sayfamıza buradan
                  ulaşabilirsiniz.</a></div>
              <p>&nbsp;</p>


              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_6" role="tablist">
                  <li><a href="https://goo.gl/maps/NAhuCmpYDT2677p27" target="_blank"><i class="fa fa-map-marker"
                        style="margin-right:10px;"></i>Eskişehir (HQ)</a></li>
                  <li><a href="https://goo.gl/maps/RcsHXyWfv71bAHhFA" target="_blank"><i class="fa fa-map-marker"
                        style="margin-right:10px;"></i>Bursa</a></li>

                  <li><a href="https://goo.gl/maps/FVLtbYQZZszJgMfz6" target="_blank"><i class="fa fa-map-marker"
                        style="margin-right:10px;"></i>Bilecik</a></li>
                  <li><a href="https://www.google.com/maps?q=37.05673599243164,27.3511962890625&z=17&hl=tr"
                      target="_blank"><i class="fa fa-map-marker" style="margin-right:10px;"></i>Bodrum</a></li>
                  <li><a href="https://www.google.com/maps?q=39.43760299682617,29.95660400390625&z=17&hl=tr"
                      target="_blank"><i class="fa fa-map-marker" style="margin-right:10px;"></i>Kütahya</a></li>
                  <li><a href="https://goo.gl/maps/YW7YKquK7T5MPrMWA" target="_blank"><i class="fa fa-map-marker"
                        style="margin-right:10px;"></i>Uşak</a></li>
                  <div id="myTabContent_6" class="tab-content"> </div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">

                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Dimes.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Do%c4%9fu%c5%9f.png">
                </p>
                <!-- <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Ender.png">
                </p> -->
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Erikli.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Nestle.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Haribo.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/duzey.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/K%c4%b1z%c4%b1lay.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/purebaby.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Sleepy.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/tat.png">
                </p>
                <!-- <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Mixmey.png">
                </p> -->

                <!-- <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Original%20Gourmet.png">
                </p> -->
                <!-- <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/PM.png">
                </p> -->
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Red%20Bull.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/Uluda%c4%9f.png">
                </p>
                <p class="col-xs-6 col-sm-4 col-md-3 col-lg-2 text-center" title="">
                  <img width="100%" style="border-radius: 35px; float: left; margin-right:15px;"
                    src="assets/images/company/philipmorristext-en.png">
                </p>
              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/AlpataAS/" target=" _blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alpata_as" target="_blank" class="alp-social"><i
                    class="fa fa-twitter"></i></a>
                <a href="https://www.instagram.com/alpataas/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(1)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>

  <div *ngIf="gosterilenIsleme == 2" id="automotive">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(2)">×</a>
          <h1 class="preview-title">NECDET ALPATA AS. AUTOMOTIVE BRANCH</h1>
          <p class="preview-subtitle"></p>
        </div>

        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/3ad20862-0226-4548-ac82-e6487120c922_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>
              <p>Alpata Automotive Company joined the Group in 1990. It is the authorized dealer and after-sales center
                of Opel and after-sales center of Chevrolet, General Motors brands, in its region.</p>

              <p>Necdet Alpata A.S. The Automotive Branch has also held the title of “Golden Opel Service” since 2004
                with its service quality and technicians with the title of Master Tech.</p>

              <p>Since 2019, ALPATA also provides sales and after sales services of Peugeot and Citroen which are now
                Stellantis brands, a leading global automaker and provider of innovative mobility solutions, in its
                renovated showroom </p>

              <p>In addition to this, second hand sales are also made under Spoticar brand.</p>
              <p>The Company has modern facilities with service unit, parks, cafes and green areas 17.000 square meters
                area and actively serves tens of thousands of Peugeot, Opel, Citroen & Chevrolet branded vehicles in
                Eskisehir and neighboring
                cities.
              </p>
              <p></p>




              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_10" role="tablist">
                  <div id="myTabContent_10" class="tab-content"> </div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <img class="img-responsive" style="border-radius: 35px;margin-bottom:30px;"
                src="assets/images/company/alpataotomotiv.png">
              <div class="clearfix"></div>
              <div class="col-md-3">
                <h2 class="text-center"><strong>PEUGEOT</strong></h2>
                <div class="company-social" style="margin-top:25px;">
                  <a href="https://www.facebook.com/PeugeotAlpataOto/" target="_blank" class="alp-social"><i
                      class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/peugeotalpata/" target="_blank" class="alp-social"><i
                      class="fa fa-instagram"></i></a>
                </div>
                <div class="clearfix"></div>
                <div style="margin-top: 25px;">
                  <p class="text-center"><a class="btn btn-alpata" href="https://bayi.peugeot.com.tr/alpata"
                      target="_blank">VISIT WEB SITE</a></p>
                </div>
              </div>
              <div class="col-md-3">
                <h2 class="text-center"><strong>CITROEN</strong></h2>
                <div class="company-social" style="margin-top:25px;">
                  <a href="https://www.facebook.com/citroenAlpata/" target="_blank" class="alp-social"><i
                      class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/peugeotalpata/" target="_blank" class="alp-social"><i
                      class="fa fa-instagram"></i></a>
                </div>
                <div class="clearfix"></div>
                <div style="margin-top: 25px;">
                  <p class="text-center"><a class="btn btn-alpata" href="https://bayi.peugeot.com.tr/alpata"
                      target="_blank">VISIT WEB SITE</a></p>
                </div>

              </div>
              <div class="col-md-3">
                <h2 class="text-center"><strong>OPEL</strong></h2>
                <div class="company-social" style="margin-top:25px;">
                  <a href="https://www.facebook.com/opelalpata" target="_blank" class="alp-social"><i
                      class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/opelalpata/" target="_blank" class="alp-social"><i
                      class="fa fa-instagram"></i></a>
                </div>
                <div class="clearfix"></div>
                <div style="margin-top: 25px;">
                  <p class="text-center"><a class="btn btn-alpata" href="https://opel.alpata.com/" target="_blank">VISIT
                      WEB SITE</a></p>
                </div>
              </div>
              <div class="col-md-3">
                <h2 class="text-center"><strong>SPOTİCAR </strong></h2>
                <div class="company-social" style="margin-top:25px;">
                  <a href="https://www.facebook.com/Spoticar-Alpata-101300115770772 " target="_blank"
                    class="alp-social"><i class="fa fa-facebook"></i></a>
                  <a href="https://www.instagram.com/spoticaralpata/ " target="_blank" class="alp-social"><i
                      class="fa fa-instagram"></i></a>
                </div>
                <div class="clearfix"></div>
                <div style="margin-top: 25px;">
                  <p class="text-center"><a class="btn btn-alpata" href="https://www.spoticar.com.tr/ "
                      target="_blank">VISIT
                      WEB SITE</a></p>
                </div>
              </div>
              <div class="clearfix"></div>

            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(2)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>

  </div>

  <div *ngIf="gosterilenIsleme == 3" id="insurance">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(3)">×</a>
          <h1 class="preview-title">ALPATA INSURANCE BROKERAGE COMPANY </h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/alpata-sigorta-en.png">
          </div>
        </div>

        <div class="imac-frame hidden">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/2073de91-8cbe-4d99-adea-6305b30c2184_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>
              <p>Established in 1995, by offering brokerage services for Anadolu Insurance products, Alpata Insurance,
                eventually added Allianz, Axa, Gulf, Mapfre, Groupama, AkSigorta, Sompo Japan, Acıbadem Sigorta, HDI,
                Halk Sigorta ve Türkiye
                Sigorta products into its portfolio. </p>

              <p>It is one of the largest general insurance products brokers in Turkey.</p>

              <p>Serving in the areas requiring specialized knowledge such as aviation, engineering and product
                liability insurances, Alpata Insurance is proud to offer high satisfaction to its customers.</p>
              <p>Alpata Insurance brokerage portfolio includes a wide range of insurance products such as;</p>
              <ul>
                <li>Vehicle Insurances</li>
                <li>Health insurance</li>
                <li>Residence insurance</li>
                <li>Life insurance</li>
                <li>Personal Accident Insurance</li>
                <li>Workplace Insurance</li>
                <li>Transport Insurance&nbsp;</li>
                <li>Liability Insurance&nbsp;</li>
                <li>Engineering&nbsp; Insurance</li>
                <li>Aviation Insurances</li>
                <li>Travel Insurance</li>
                <li>DASK (Mandatory Earthquake Insurance)</li>
                <li>Education Insurance&nbsp;</li>

              </ul>



              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_13" role="tablist">
                  <div id="myTabContent_13" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/AlpataSigorta/" target=" _blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://www.instagram.com/alpatasigorta/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>
              <div class="clearfix"></div>
              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="http://www.alpatasigorta.com/"
                    target="_blank">VISIT WEB SITE</a></p>
              </div>

              <div class="clearfix"></div>


            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(3)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 4" id="aviation">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(4)">×</a>
          <h1 class="preview-title">ALP AVIATION</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/tesisler.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/cbb2a481-ddfc-4850-88ff-95b98b4efeef_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>

              <p>Established in 1998 in Eskisehir, Turkey; Alp Aviation is a privately owned company with absolute
                dedication to the aerospace industry and its highest standards. With its efficient operations, quality,
                design and lean manufacturing
                practices, Alp Aviation manufactures flight critical and rotating parts, systems and subsystems for
                various customers around the world.</p>

              <p>Having approximately 1300 highly skilled employees, Alp Aviation utilizes more than 200 new generation
                multi-axes machines and CMM quality control equipment, performs various tests including non-destructive
                tests, coatings
                and other special processes and has a wide range of laboratory capabilities. Alp Aviation has over 70
                distinct special processes some of which can rarely be found throughout the world, and all approved by
                NADCAP and OEM
                customers.
              </p>

              <p>Alp Aviation, together with its efficient supply chain demonstrate extensive experience in machining
                and processing of titanium, nickel, aluminium, steel, stainless steel, copper alloys and super alloys.
                Alp Aviation manufactures
                Helicopter Dynamic Parts & Assemblies, Gears and Gearboxes, Helicopter Tail Rotor Drive Shaft System
                (TRDS) Parts & Assemblies, Dynamic & Static Engine and APU Parts including jet engine Fan and Compressor
                Integrally Bladed
                Rotors, Landing Gear Parts & Assemblies, Structural Parts & Assemblies, Hydraulic and Fuel Systems and
                Tube Assemblies to the world’s aviation giants such as Lockheed Martin (Sikorsky, LM Aero), Raytheon
                Technologies (Pratt
                & Whitney, Pratt & Whitney Canada, Collins Aerospace (UTC Aerospace Systems, HS & GLG & Actuation
                Systems)) Lockheed Martin Aeronautics, Heroux Devtek, Honeywell, Boeing, TEI TUSAŞ Motor Sanayii A.Ş and
                Aselsan
              </p>

              <p>Today the products proudly manufactured by Alp Aviation support several rotary and fixed wing aircraft
                platforms such as Black Hawk, Seahawk, S76, S92, CH53, CH47, F-35, F-22, Boeing 737, Boeing 747, Boeing
                767, Boeing 777,
                Boeing 787, Airbus 320, Airbus 330, Airbus 340, Airbus 380, Airbus A400M as well engine programs such as
                F135, F100, P&W GTF Engines, PW150, PW305, PW530, PW535, PW545, PW600. In addition to the production
                programs, TEI
                operates as the main contractor in the design, development and production of the accessory gearbox for
                the TS1400 engine, which is uniquely developed by TEI. The first Accessory Gearbox designed and produced
                in this context
                was delivered to TEI in 2021.</p>

              <p>While offering best value for its customers with its efficient operations and Industry 4.0 practices;
                Alp Aviation particularly provides significant cost advantage compared to classical production methods
                using the "ceramic
                cutters" technology specifically developed and patented for the processing of nickel alloys.
              </p>

              <p>Alp Aviation has become an R&D center as of November 14, 2013.</p>


              <p></p>




              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_14" role="tablist">
                  <div id="myTabContent_14" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/alphavacilik" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alp_havacilik" target="_blank" class="alp-social"><i
                    class="fa fa-twitter"></i></a>
                <a href="https://www.linkedin.com/company/alp-havac%C4%B1l%C4%B1k" target="_blank" class="alp-social"><i
                    class="fa fa-linkedin"></i></a>
                <a href="https://www.youtube.com/channel/UCJb2rOaWiF7rC8BC8QjxNlw" target="_blank" class="alp-social"><i
                    class="fa fa-youtube"></i></a>
                <a href="https://www.instagram.com/alp_havacilik/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="http://www.alp.com.tr " target="_blank">WEB
                    SİTESİ</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(4)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 5" id="technologies">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a class="close-preview" (click)="gosterilenIsletmeGosterGizle(5)">×</a>
          <h1 class="preview-title">NECDET ALPATA AS. TECHNOLOGY BRANCH</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;"
              src="assets/images/company/Alpata-Teknoloji-en.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/b15c2ea5-5819-45f9-a196-4fbca8860f6c_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>
              <p>Alpata Group acquired Necdet Alpata A.Ş. Technology Branch in 2000. Necdet Alpata A.Ş. Technology
                Branch is effectively serving its customers through its head office in Eskişehir Technopolis Center.
                Necdet Alpata A.Ş. Technology Branch provides information technologies and software
                solutions to small and medium size businesses, large industrial companies, public institutions and
                organizations, trade chambers, and commodity exchanges. Necdet Alpata A.Ş. Technology Branch is the
                research and development base where plans are made to move Alpata Group further ahead with projects
                deemed worthy of TUBITAK (The Scientific and Technological Research Council of Turkey) and European
                Union support.
                &nbsp;
              </p>

              <p>Developed by Necdet Alpata A.Ş. Technology Branch, Stock Exchange Market Information Systems Software
                is used by a big majority of all 113 Commodity Exchange Markets in Turkey today and all business
                processes of Commodity Exchange Markets are integrally followed through this software.</p>

              <p>The first licensed agricultural warehousing companies of Turkey, specializing in grain and hazelnut,
                established under the Licensed Warehousing Law no. 5300, operate with the Licensed Warehousing
                Automation System developed by Necdet Alpata A.Ş. Technology Branch.</p>

              <p>Necdet Alpata A.Ş. Technology Branch fulfills a diverse mission by bringing all Alpata Group employees
                together with the latest developments in relevant sectors in the field of usage, sharing, and the
                development of information.
              </p>
              <p></p>
              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_15" role="tablist">
                  <div id="myTabContent_15" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/alpatayazilim" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alpatayazilim" target="_blank" class="alp-social"><i
                    class="fa fa-twitter"></i></a>
                <a href="https://www.linkedin.com/company/alpata-yaz-l-m-ve-teknoloji" target="_blank"
                  class="alp-social"><i class="fa fa-linkedin"></i></a>
                <a href="https://www.instagram.com/alpatayazilim/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="http://www.alpatateknoloji.com"
                    target="_blank">VISIT WEB
                    SITE</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(5)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 6" id="alpteknikaviation">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a class="close-preview" (click)="gosterilenIsletmeGosterGizle(6)">×</a>
          <h1 class="preview-title">
            <h1 class="preview-title">ALPTEKNIK AVIATION</h1>
          </h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;"
              src="assets/images/company/Alpteknik-havacılık-en.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/9fd40c5f-aa8d-4da2-8cec-85374ab956e2_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
              <p>
              </p>
              <p>Established in 2013 as s subsidiary of Alp Aviation located in Eskisehir, Alpteknik Aviation offers
                after-sales services in the aviation sector in Ankara. Alpteknik has been appointed by Sikorsky Aircraft
                Corporation, a Lockheed
                Martin company, as the sole distributor for Sikorsky fixed and rotary wing aircraft spare parts,
                accessories and repairs in Turkey.</p>

              <p>Alpteknik is also the Sales Representative for the commercial aircrafts Sikorsky S-76, S-92, S-61 and
                M28 in Turkey and Central Asia Countries.</p>

              <p>Alpteknik Aviation provides service as spare parts supplier to the commercial operators of new and
                pre-owned Sikorsky platforms in Turkey and the Central Asia. It is effectively serving to its customers
                through its head office
                in Ankara and its branches in Eskisehir and Izmir Free Trade Zone.</p>

              <p></p>




              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_16" role="tablist">
                  <div id="myTabContent_16" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/AlpJet/" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alpjet" target="_blank" class="alp-social"><i
                    class="fa fa-twitter"></i></a>
                <a href="https://www.linkedin.com/alpjet" target="_blank" class="alp-social"><i
                    class="fa fa-linkedin"></i></a>
                <a href="https://www.instagram.com/alpjet/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="http://www.alptechnic.com" target="_blank">VISIT
                    WEB
                    SITE</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="en#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(6)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 7" id="alpatasrl">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(7)">×</a>
          <h1 class="preview-title">ALPATA S.R.L</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;" src="assets/images/company/Alpata-SRL.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color: black; background-image: url(assets/images/company/AlpataSRL_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify; padding-top:50px;">
              <p>
              </p>
              <p>
                Alpata SRL is a global company based in Italy that has been operating since 2019 and provides supply to
                some of the world's most significant high-alloy metal manufacturers. </p>

              <p>Our company engages in the scrap trade of high-speed and high-temperature-resistant metals used in the
                aviation and defense industries. Our goal is to maximize profitability for our customers and meet the
                needs of the industry.
              </p>

              <!-- <p>Alpteknik Aviation, located in Turkey and Central Asia, also serves as a spare parts supplier to
                commercial operators of new and used Sikorsky platforms. Alpteknik Aviation effectively serves its
                customers through its headquarters
                in Ankara and its branches in the Eskişehir and İzmir Free Trade Zones.</p> -->

              <p></p>
              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_16" role="tablist">
                  <div id="myTabContent_16" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <!-- <a href="https://www.facebook.com/AlpJet/" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a> -->
                <!-- <a href="https://twitter.com/alpjet" target="_blank" class="alp-social"><i
                    class="fa fa-twitter"></i></a> -->
                <a href="https://www.linkedin.com/company/alpatasrl" target="_blank" class="alp-social"><i
                    class="fa fa-linkedin"></i></a>
                <!-- <a href="https://www.instagram.com/alpjet/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a> -->
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="https://alpatametalli.it/" target="_blank">VISIT
                    WEB
                    SITE</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(7)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>
  <div *ngIf="gosterilenIsleme == 8" id="alpatasrl">
    <div class="project-preview">

      <div class="container">

        <div class="preview-header text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(8)">×</a>
          <h1 class="preview-title">ALPATA AEROSPACE</h1>
          <p class="preview-subtitle"></p>
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify">
            <img class="img-responsive" style=" margin-bottom:30px;"
              src="assets/images/company/Alpata-havacilik-banner-en.png">
          </div>
        </div>

        <div class="imac-frame hidden" style="display: none;">
          <span class="loader"></span>
          <div class="imac-screen imac-slider flexslider"></div>

        </div>
      </div>

      <div
        style="width: 100%; position: relative; background-size: cover; background-position: center center; color:black; background-image: url(assets/images/company/Alpata-havacilik_BG.png);"
        id="bgCompany">
        <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay">
        </div>
        <div class="container">

          <div class="row">
            <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify; padding-top:50px;">
              <p>
              </p>
              <p>Our company, established in 2024 in Eskişehir Organized Industrial Zone, engages in machining
                production
                for aerospace and defense industry components. Situated on a 7,000 m² open area, our facility boasts a
                robust machine park within a 1,700 m² closed area.</p>
              <p>
                Committed to principles of reliability, honesty, and
                quality, our company prioritizes customer satisfaction. We constantly strive to embrace technology and
                innovations, aiming to be better, faster, and more quality-driven. Always focusing on excellence, our
                company takes pride in providing services that meet the highest standards.
              </p>
              <p></p>
              <div class="bs-example bs-example-tabs" style="padding-top:15px;" id="filter-works">
                <ul id="myTab_16" role="tablist">
                  <div id="myTabContent_16" class="tab-content"></div>
                </ul>


              </div>
              <div class="clearfix"></div>

              <div class="row text-center">


              </div>

              <div class="clearfix"></div>

              <div class="company-social" style="margin-top:25px;">
                <a href="https://www.facebook.com/profile.php?id=61553670151388" target="_blank" class="alp-social"><i
                    class="fa fa-facebook"></i></a>
                <a href="https://twitter.com/alpatahavacilik" target="_blank" class="alp-social"> <svg
                    viewBox="0 0 24 24" aria-label="X" role="img" style="
                    fill: #0F1D41; width: 31px; margin-bottom: -5px;">
                    <g>
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z">
                      </path>
                    </g>
                  </svg></a>
                <a href="https://www.linkedin.com/company/alpata-havac%C4%B1l%C4%B1k/" target="_blank"
                  class="alp-social"><i class="fa fa-linkedin"></i></a>
                <a href="https://www.instagram.com/alpatahavacilik/" target="_blank" class="alp-social"><i
                    class="fa fa-instagram"></i></a>
              </div>

              <div class="clearfix"></div>

              <div style="margin-top: 25px;">
                <p class="text-center"><a class="btn btn-alpata" href="https://alpatahavacilik.com.tr/"
                    target="_blank">VISIT
                    WEB
                    SITE</a></p>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="container">
        <div class="preview-footer text-center">
          <a href="#portfolio" class="close-preview" (click)="gosterilenIsletmeGosterGizle(8)">×</a>
        </div>
      </div>
      <!--End container -->

    </div>
  </div>

  <!-- End Row -->


  <!-- End Projects Container -->



  <!-- End container -->
  <!--==== Project Preview Panel (DO NOT REMOVE)====-->

  <div id="preview-scroll"></div>

  <div id="project-preview">

    <div class="container">

      <div class="preview-header text-center">
        <a class="close-preview" href="en#">&times;</a>
        <h1 class="preview-title"></h1>
        <p class="preview-subtitle"></p>
      </div>

      <div class="imac-frame">
        <span class="loader"></span>
        <div class="imac-screen imac-slider flexslider"></div>

      </div>
    </div>

    <div style="width:100%; position: relative; background-size:cover; background-position:center; color:black;"
      id="bgCompany">
      <div style="width:100%; height:100%; position:absolute; background: rgba(255,255,255,0.85);" id="overlay"></div>
      <div class="container">

        <div class="row">
          <div id="preview-content" class="col-sm-10 col-sm-offset-1" style="text-align:justify"></div>
        </div>
      </div>


    </div>
    <div class="container">
      <div class="preview-footer text-center">
        <a class="close-preview" href="en#">&times;</a>
      </div>
    </div>
    <!--End container -->

  </div>
  <!--End #project-preview panel-->

</section>
<section id="hr" class="white-bg padding-top-bottom">

  <div class="container">

    <h1 class="section-title">CAREER</h1>
    <div class="row">
      <!--=== Contact Form ===-->

      <form class="forms-sample contact-form col-md-6 col-sm-offset-3" (submit)="ekleGuncelle(0)" ngNativeValidate>
        <div class="row">
          <div class="form-group">
            <div class=" controls">
              <select id="contact-company" name="SirketTipi" placeholder="Please select a company" required="true"
                [(ngModel)]="item.SirketTipi" class="form-control requiredField label_better">
                <option value="">Select a company</option>
                <option value="0">NECDET ALPATA MARKETING LOGISTICS AND TOURISM INDUSTRY AND TRADE INC.</option>
                <option value="1">NECDET ALPATA AS. AUTOMOTIVE BRANCH</option>
                <option value="2">ALPATA INSURANCE BROKERAGE COMPANY </option>
                <option value="3">ALP AVIATION</option>
                <option value="4">NECDET ALPATA AS. TECHNOLOGY BRANCH</option>
                <option value="5">ALPTEKNIK AVIATION</option>
                <option value="6">ALPATA S.R.L</option>
                <option value="7">ALPATA AEROSPACE</option>
              </select>
              <i class="fa fa-building-o"></i>
            </div>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Ad" name="Ad" autocomplete="off" placeholder="Name"
              [(ngModel)]="item.Ad" required="true" />
            <i class="fa fa-user"></i>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Soyad" name="Soyad" autocomplete="off" placeholder="Surname"
              [(ngModel)]="item.Soyad" required="true" />
            <i class="fa fa-user"></i>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Email" name="Email" autocomplete="off" placeholder="E-mail"
              [(ngModel)]="item.Email" required="true" />
            <i class="fa fa-envelope"></i>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Telefon" name="Telefon" autocomplete="off" placeholder="Phone"
              [(ngModel)]="item.Telefon" required="true" />
            <i class="fa fa-phone"></i>
          </div>
          <div class="form-group">
            <i class="fa fa-file-o"></i>
            <input type="file" class="form-control" id="file" (change)="handleFileInput($event.target.files)">
          </div>

          <div class="form-check" style="margin-top:40px;margin-bottom:10px;text-align:center;">

            <label style=" font-size: 14px">
              <input type="checkbox" class="form-check-input requiredField" required="true" name="IsGDPR" id="IsGDPR">
              I have read, understood and accept the <a href="en#" data-toggle="modal" data-target="en#gdprModal"
                style="color: red;">
                personal data information and confirmation text
              </a>.
            </label>
          </div>

          <div class="col-md-12">
            <button [disabled]="ekleGuncelleIsLoading" type="submit" class="btn btn-alpata btn-block">
              <span *ngIf="ekleGuncelleIsLoading" role="status" aria-hidden="true"></span>
              <i class="fa fa-location-arrow"></i>Send
            </button>
          </div>
        </div>
      </form>

      <!-- End contact-form -->
    </div>
  </div>

</section>
<!-- Modal -->
<div id="gdprModal" class="modal fade" role="dialog" style="z-index: 9999">
  <div class="modal-dialog modal-lg">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="modal-title">&nbsp;</h4>
      </div>
      <div class="modal-body">
        <p><strong>6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU VE BU KANUN KAPSAMINDAKİ HAKLARINIZ İLE İLGİLİ
            BİLGİLENDİRME, BEYAN ve ONAY FORMU</strong></p>

        <p>07.04.2016 tarihli ve 29677 sayılı Resmi Gazetede yayımlanan 6698 sayılı Kişisel Verilerin Korunması Kanunu
          (KVKK) uyarınca veri sorumlusu (VS) sıfatına haiz şirketimiz tarafından elde edilmiş/edilecek ya da
          şirketimizle paylaştığınız/paylaşacağınız
          şahsınıza ait her t&uuml;rl&uuml; bilginin (kişisel veri), aşağıda a&ccedil;ıklanan &ccedil;er&ccedil;evede ve
          KVKK&rsquo;da &ouml;ng&ouml;r&uuml;len şekillerde şirketimizce işleneceği ve bilgilerinizin otomatik olan ya
          da olmayan
          yollarla elde edilmesi, kaydedilmesi, depolanması, a&ccedil;ıklanması, aktarılması, elde edilebilir hale
          getirilmesi de dahil olmak &uuml;zere bilgileriniz &uuml;zerinde ger&ccedil;ekleştirilen her t&uuml;rl&uuml;
          işlemin &ldquo;kişisel
          verilerin işlenmesi&rdquo; anlamına geldiğini bilgilerinize sunarız.</p>

        <p><strong>KİŞİSEL VERİLERİN İŞLENME AMA&Ccedil;LARI VE HUKUKİ SEBEPLERİ</strong></p>

        <p>Başta İş, İş Sağlığı ve G&uuml;venliği, Sosyal Sigortalar ve Genel Sağlık Sigortası olmak &uuml;zere t&uuml;m
          ulusal/uluslararası mevzuat ve/veya bunlara dayalı olarak Bakanlık ve diğer yetkili otoritelerce yayımlanmış
          olan ikincil d&uuml;zenlemelerle,
          şirketimizin faaliyetleri ile ilgili olarak taraf olduğu/olacağı s&ouml;zleşmeler kapsamında şirketimizin
          g&uuml;venlik, prensip, prosed&uuml;r, ilke, y&uuml;k&uuml;ml&uuml;l&uuml;k ve taahh&uuml;tlerin yerine
          getirilmesi (personel
          kayıtları, kimlik tespiti, bilgi saklama, raporlama, bilgilendirme, asıl işveren
          y&uuml;k&uuml;ml&uuml;l&uuml;ğ&uuml;, otopark kayıtları, kamera g&ouml;r&uuml;nt&uuml;leri, mali belge
          d&uuml;zenleme, vb.) ile s&ouml;zleşmeler mucibince
          gerekli kayıt ve belgelerin d&uuml;zenlenmesi, hizmet ve y&uuml;k&uuml;ml&uuml;l&uuml;klerin kesintisiz
          eksiksiz olarak yerine getirilmesi ve s&uuml;rd&uuml;r&uuml;lmesi, taleplerinizin karşılanması, pazarlama ve
          Reklam faaliyetlerinin
          y&uuml;r&uuml;t&uuml;lmesi vb. sebeplerle &ouml;zel nitelikli kişisel verileriniz de dahil olmak &uuml;zere
          şirketimizce işlenmektedir.</p>

        <p><strong>KİŞİSEL VERİLERİN TOPLANMA Y&Ouml;NTEMİ VE HUKUKİ SEBEBİ</strong></p>

        <p>Yukarıda a&ccedil;ıklanan sebeplerle kişisel verileriniz şirketimiz &ccedil;alışanları, internet sitesi,
          &ccedil;ağrı merkezi (operat&ouml;r) ve benzeri diğer t&uuml;m işleyen/işleyecek kanallarla otomatik ya da
          otomatik olmayan yollarla
          s&ouml;zl&uuml;, yazılı ve elektronik olarak toplanabilmektedir.</p>

        <p>Bu kapsamda; isim ve soyisminiz, T&uuml;rkiye Cumhuriyeti kimlik, vergi numaranız, T.C. kimlik bilgileriniz,
          t&uuml;zel kişi ortaklık bilgileriniz/yetki sınırlarınız, pasaport, s&uuml;r&uuml;c&uuml;- iş makinası
          operat&ouml;r&uuml;- iş
          yeterlilik vb belgeleriniz, eğitim/kurs belge ve bilgileriniz, ara&ccedil; ruhsat bilgileriniz, arşiv
          araştırma formu, adli sicil kaydı, fotoğraf, sağlık raporu, biyometrik ve genetik verileriniz, işyeri kamera
          g&ouml;r&uuml;nt&uuml;leri,
          &ouml;deme-banka ve kredi kartı bilgileriniz, iletişim numalarınız ve adresiniz, işyeri ve alışveriş
          bilgileriniz, iş sağlığı ve g&uuml;venliği a&ccedil;ısından gerekli belgeleriniz ve bunlarla sınırlı olmamak
          &uuml;zere &ouml;zel
          ve/veya &ouml;zel olmayan kişisel verileriniz toplama,işleme,depolama, kaydetme, a&ccedil;ıklama, aktarma ve
          elde edilebilir hale getirilmektedir.
        </p>

        <p>Yine &uuml;&ccedil;&uuml;nc&uuml; kişiler (iş-iş&ccedil;i bulma faaliyeti y&uuml;r&uuml;ten web siteleri ve
          kurum/kuruluşlar, kişisel veri sahibi ile arasında m&uuml;n&rsquo;akid s&ouml;zleşme olan kurum/kuruluşlar,
          &ccedil;ağrı merkezleri,
          kişisel veri sahibinin şirketimizde yapacağı faaliyeti organize eden/sağlayan kurum/kuruluşlar, anlaşmalı
          destek hizmet sağlayıcılarından, şirketimiz yurt i&ccedil;i ve yurt dışı ortaklarından, internet sitemize
          yapmış olduğunuz ziyaret
          esnasında oluşan &ccedil;erezlerden vb) yukarıda belirtilen &ouml;zel nitelikli kişisel veriler dahil olmak
          &uuml;zere her t&uuml;rl&uuml; kişisel veriniz toplama,işleme,depolama, kaydetme, a&ccedil;ıklama, aktarma ve
          elde edilebilir
          hale getirilmektedir.</p>

        <p><strong>KIŞISEL VERILERIN AKTARILABİLECEĞİ KİŞİ YADA KURULUŞLAR</strong></p>

        <p>T&uuml;m ulusal/uluslararası mevzuat ve/veya bunlara dayalı olarak Bakanlık ve diğer yetkili otoritelerce
          yayımlanmış olan ikincil d&uuml;zenlemelerle, şirketimizin faaliyetleri ile ilgili olarak taraf olduğu/olacağı
          s&ouml;zleşmeler kapsamında
          kişisel bilgileri işleme izin-hak ve yetkisine sahip kişi/kuruluşlar ile grup şirketlerimiz başta olmak
          &uuml;zere şirketimizin yurt i&ccedil;i/dışındaki ortakları, şirketimizce hizmet/destek/danışmanlık alınan ya
          da işbirliği yapılan
          kişi/kurum/kuruluşlara aktarılabilecektir.</p>

        <p><strong>ELEKTRONIK İLETILER</strong></p>

        <p>Kabul etmiş olmanız halinde size doğrudan (&ouml;r. telefon, e-posta, SMS, sosyal ağlar, posta) bilgilendirme
          vs. i&ccedil;in g&uuml;ncellemeler ve teklifler sunabiliriz. Bu &ccedil;er&ccedil;evede diğer kişisel
          verilerinizi de kullanabiliriz.</p>

        <p><strong>VERİ SAHİBİNİN HAKLARI</strong></p>

        <p>6698 sayılı Kişisel Verileri Koruma Kanunu&rsquo;nun 28. Maddesinde &ouml;ng&ouml;r&uuml;len haller saklı
          kalmak kaydıyla anılan kanunun 11. Maddesi kapsamında; Kişisel veri işlenip işlenmediğini &ouml;ğrenme,
          işlenmişse buna ilişkin bilgi
          talep etme, kişisel verilerin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
          &ouml;ğrenme, Yurt i&ccedil;inde veya yurt dışında kişisel verilerin aktarıldığı &uuml;&ccedil;&uuml;nc&uuml;
          kişileri bilme, Kişisel
          verilerin eksik veya yanlış işlenmiş olması h&acirc;linde bunların d&uuml;zeltilmesini isteme, Kanun&#39;un 7
          nci maddesinde &ouml;ng&ouml;r&uuml;len şartlar &ccedil;er&ccedil;evesinde kişisel verilerin silinmesini veya
          yok edilmesini
          isteme ve bu kapsamda şirketimizce yapılan işlemlerinin bilgilerinin altarıldığı 3. Kişilere bildirilmesini
          talep etme, İşlenen verilerin m&uuml;nhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişinin
          kendisi aleyhine
          bir sonucun ortaya &ccedil;ıkmasına itiraz etme ve kanuna aykırı olarak işlenmesi sebebiyle zarara uğraması
          h&acirc;linde zararın giderilmesini talep etme haklarına sahipsiniz.</p>

        <p>Bu madde kapsamında haklarınızı, d&uuml;zenlemenin y&uuml;r&uuml;rl&uuml;k tarihi olan 07.10.2016 tarihinden
          itibaren kullanmanız m&uuml;mk&uuml;n olup taleplerinizin yerine getirilmesini teminen şirketimizce yapılacak
          masrafları KVKK&rsquo;nın
          &ldquo;Veri Sorumlusuna Başvuru&rdquo; başlıklı 13. Maddesinde belirtilen tarifeye g&ouml;re tarafınızdan
          talep etme hakkımız saklıdır. Yukarıda anılan haklarınızı kullanmayı talep etmeniz halinde l&uuml;tfen&nbsp;
          <strong>alpatagida@alpata.com</strong> adresine eposta g&ouml;nderiniz.</p>

        <p><strong>ONAY</strong></p>

        <p>6698 sayılı KVKK&#39;na uygun olarak yukarıda a&ccedil;ıklanan bilgiler &ccedil;er&ccedil;evesinde şirketiniz
          ve/veya şirketiniz adına personeliniz, şubeleriniz, &ccedil;ağrı merkeziniz, bağlı şirketleriniz/ortaklarınız
          tarafından ya da
          internet siteleriniz ile sosyal medya sayfalarınız ve bunlarla sınırlı olmamak &uuml;zere her t&uuml;rl&uuml;
          kanallar aracılığı ile; kişisel ve/veya &ouml;zel nitelikli kişisel verilerimin; tamamen veya kısmen elde
          edilmesi, kaydedilmesi,
          depolanması, değiştirilmesi, g&uuml;ncellenmesi, periyodik olarak kontrol edilmesi, yeniden d&uuml;zenlenmesi,
          sınıflandırılması, Şirketinizin birlikte &ccedil;alıştığı ya da kanunen y&uuml;k&uuml;ml&uuml; olduğu kamu
          kurum ve kuruluşlarıyla
          ve/veya T&uuml;rkiye&#39;de veya yurt dışında mukim olan 3. kişilerle paylaşılması, yurtdışına aktarılması ya
          da kullanılmasının engellenmesi de dahil olmak &uuml;zere işlenmesine, onay, teklif, bilgilendirme vs.
          i&ccedil;in ticari
          elektronik iletiler ile tarafıma teklif/bilgilendirme yapılmasına konu hakkında teredd&uuml;de yer vermeyecek
          şekilde bilgi sahibi olarak, aydınlatılmış a&ccedil;ık rızam ile onay veriyorum.</p>

        <p>*Kişisel verilerinizin silinmesini talep etmeniz halinde kanunen tutulması zorunlu olan s&uuml;renin sonunda
          verileriniz silinecektir.</p>

        <p>Bilgilendirildim, Kabul Ediyorum.</p>

      </div>
    </div>
  </div>
</div>
<section id="contact" class="contact white-bg padding-top-bottom">

  <div class="container">

    <h2 class="section-title">CONTACT US</h2>
    <div class="row">


      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in" style="font-size:9pt;">
        <a class="icon" target="_blank"><i style="font-size:20pt;" class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">NECDET ALPATA MARKETING LOGISTICS AND TOURISM INDUSTRY AND TRADE INC.</h2>
        <p style="min-height:72px;">Zafer Mahallesi Esener Sokak No:3 Tepebaşı Eskişehir / Turkey</p>
        <strong>Tel:</strong> 0 (222) 323 89 00<br>
        <strong>Fax:</strong> 0 (222) 322 13 14<br> &nbsp;
        <strong>Mail: </strong> info@alpata.com
        <br>
        <br>
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in" style="font-size:9pt;">
        <a class="icon" href="https://opel.alpata.com/" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">NECDET ALPATA AS. AUTOMOTIVE BRANCH</h2>
        <p style="min-height:72px;">Ankara Asfaltı 75.Yıl Mah. Çevreyolu Bulvarı No:2 Odunpazarı Eskişehir / Turkey</p>
        <strong>Tel:</strong> 0 (222) 228 03 30<br>
        <strong>Fax:</strong> 0 (222) 228 03 39<br>
        <strong>Web:</strong> <a href="https://opel.alpata.com/" target="_blank">http://www.alpataotomotiv.com</a><br>
        <strong>Mail: </strong> opelsat@alpata.com
        <br>
        <br>
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in" style="font-size:9pt;">
        <a class="icon" href="http://www.alpatasigorta.com/" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">ALPATA INSURANCE BROKERAGE COMPANY </h2>
        <p style="min-height:72px;">Ankara Asfaltı 75. Yıl Mah. Çevreyolu Bulvarı No:2 Odunpazarı Eskişehir / Turkey</p>
        <strong>Tel:</strong> 0 (222) 228 03 30<br>
        <strong>Fax:</strong> 0 (222) 228 03 39<br>
        <strong>Web:</strong> <a href="http://www.alpatasigorta.com/"
          target="_blank">http://www.alpatasigorta.com/</a><br>
        <strong>Mail: </strong> sigortainfo@alpata.com
        <br>
        <br>
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in" style="font-size:9pt;">
        <a class="icon" href="http://www.alp.com.tr " target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">ALP AVIATION</h2>
        <p style="min-height:72px;">Organize Sanayi Bölgesi 8. Cadde 26110 Eskişehir / Turkey</p>
        <strong>Tel:</strong> 0 (222) 236 13 00<br>
        <strong>Fax:</strong> 0 (222) 236 12 85<br>
        <strong>Web:</strong> <a href="http://www.alp.com.tr " target="_blank">http://www.alp.com.tr </a><br>
        <strong>Mail: </strong> alphavacilik@alp.com.tr
        <br>
        <br>
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in" style="font-size:9pt;">
        <a class="icon" href="http://www.alpatateknoloji.com" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">NECDET ALPATA AS. TECHNOLOGY BRANCH</h2>
        <p style="min-height:72px;">Organize Sanayi Bölgesi Bilim Caddesi Yazılım Kule No:5/401 Odunpazarı Eskişehir /
          Turkey
        </p>
        <strong>Tel:</strong> 0 (222) 236 23 50<br>
        <strong>Fax:</strong> 0 (222) 236 23 52<br>
        <strong>Web:</strong> <a href="http://www.alpatateknoloji.com"
          target="_blank">http://www.alpatateknoloji.com</a><br>
        <strong>Mail: </strong> teknoloji@alpata.com
        <br>
        <br>
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in" style="font-size:9pt;">
        <a class="icon" href="http://www.alptechnic.com" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">ALPTEKNIK AVIATION</h2>
        <p style="min-height:72px;">Mustafa Kemal Mahallesi Dumlupınar Bulvarı Tepeprime İş Merkezi No:266 A Blok D:35
          Çankaya Ankara / Turkey</p>
        <strong>Tel:</strong> 0 (312) 201 87 00<br>
        <strong>Fax:</strong> 0 (312) 201 87 24<br>
        <strong>Web:</strong> <a href="http://www.alptechnic.com" target="_blank">http://www.alptechnic.com</a><br>
        <strong>Mail: </strong> spares@alp.com.tr
        <br>
        <br>
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in " style="font-size:9pt;">
      </div>
      <div class="col-sm-4 text-center contact-item scrollimation fade-right text-small in " style="font-size:9pt;">
        <a class="icon" href="https://alpatahavacilik.com.tr/en" target="_blank"><i style="font-size:20pt;"
            class="fa fa-map-marker fa-fw"></i></a>
        <h2 style="min-height:57px;">ALPATA AEROSPACE</h2>
        <p style="min-height:72px;">Organize Sanayi Bölgesi 34. Cadde Numara 15 26110 Odunpazarı/Eskişehir</p>
        <strong>Tel:</strong> 0(222) 236 84 53<br />
        <strong>Web:</strong> <a href="https://alpatahavacilik.com.tr/en"
          target="_blank">alpatahavacilik.com.tr</a><br />
        <strong>Mail: </strong> alpatahavacilik@alpata.com
        <br />
        <br />
      </div>

    </div>

    <!--Google Maps Start-->
    <div style="width: 100%;margin-top: 20px; height: 350px;" id="openmap"></div>
    <!--Google Maps End-->
    <div class="row">

      <!--=== Contact Form ===-->
      <form id="contact-form" class="col-sm-6 col-sm-offset-3" (submit)="ekleGuncelle(1)" ngNativeValidate>
        <div class="row">
          <div class="form-group">
            <input type="text" class="form-control" id="Ad" name="Ad" autocomplete="off" placeholder="Name"
              [(ngModel)]="item.Ad" required="true" />
            <i class="fa fa-user"></i>
          </div>
          <div class="form-group">
            <input type="text" class="form-control" id="Email" name="Email" autocomplete="off" placeholder="E-mail"
              [(ngModel)]="item.Email" required="true" />
            <i class="fa fa-envelope"></i>
          </div>
          <div class="form-group">
            <div class=" controls">
              <select id="contact-company" name="SirketTipi" placeholder="Please select a company" required="true"
                [(ngModel)]="item.SirketTipi" class="form-control requiredField label_better">
                <option value="">Select a company</option>
                <option value="0">NECDET ALPATA MARKETING LOGISTICS AND TOURISM INDUSTRY AND TRADE INC.</option>
                <option value="1">NECDET ALPATA AS. AUTOMOTIVE BRANCH</option>
                <option value="2">ALPATA INSURANCE BROKERAGE COMPANY </option>
                <option value="3">ALP AVIATION</option>
                <option value="4">NECDET ALPATA AS. TECHNOLOGY BRANCH</option>
                <option value="5">ALPTEKNIK AVIATION</option>
                <option value="6">ALPATA S.R.L</option>
                <option value="6">ALPATA AEROSPACE</option>
              </select>
              <i class="fa fa-building-o"></i>
            </div>
          </div>
          <div class="form-group">
            <textarea rows="6" class="form-control" id="Mesaj" name="Mesaj" autocomplete="off" placeholder="Message"
              [(ngModel)]="item.Mesaj" required="true"></textarea>
            <i class="fa fa-comment"></i>
          </div>

          <div #captchaRef2></div>

          <div class="col-md-12">
            <button [disabled]="ekleGuncelleIsLoading" type="submit" class="btn btn-alpata btn-block">
              <span *ngIf="ekleGuncelleIsLoading" role="status" aria-hidden="true"></span>
              <i class="fa fa-location-arrow"></i>Send
            </button>
          </div>
        </div>
      </form>
      <!-- End contact-form -->
    </div>
  </div>
</section>
